import React, { useState, useEffect } from "react";
import "./project.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { projectData } from "../../Data/projectData";
const Projects = () => {
  const [currentProject, setCurrentProject] = useState(null);
  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleSetCurrentProject = (project) => {
    setCurrentProject(project);
  };
  useEffect(() => {
    setCurrentProject(projectData[0]);
  }, []);
  return (
    <section className="section project-section" id="project-section">
      <div className="container h-100 d-flex flex-column">
        <div className="row p-3 p-lg-5">
          <div className="col-12">
            <h1 className="section-title">Projects</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-12 px-5">
            <Slider {...settings}>
              {projectData.map((item, idx) => (
                <div
                  className="project-card"
                  key={idx}
                  onClick={() => handleSetCurrentProject(item)}
                >
                  <div className="div">
                    <h3>{item.name}</h3>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="container h-100">
          <div className="row pt-4 px-4 h-100 project-row">
            <div className="col-12 col-lg-6">
              <div className="project-data">
                <h3 className="project-title">{currentProject?.name}</h3>
                <div className="project-links">
                  {currentProject?.gitLink && (
                    <a
                      href={currentProject?.gitLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Github
                    </a>
                  )}
                  {currentProject?.liveLink && (
                    <a
                      href={currentProject?.liveLink}
                      target="_blank"
                      rel="noreferrer"
                      className="mx-1"
                    >
                      Live
                    </a>
                  )}
                </div>
                <p className="project-description">
                  {currentProject?.description}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="project-img">
                {currentProject?.screenshot && (
                  <img src={currentProject?.screenshot} alt="screenshot" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
